<template>
    <li
            class="variant-item left-index-wrapper"
            @click="selectVariant(keynumber)"
            :class="{
                selected : questionAnswered && selectedVariant == keynumber,
                correct : isSelectionCorrect,
                incorrect : questionAnswered && !isSelectionCorrect,
            }"
    >
        <span class="left-index">{{ keynumber }}</span>
        {{ text }}
    </li>
</template>

<script>
export default {
  name: 'VariantItem',
  data: function () {
    return {}
  },
  computed: {
    isSelectionCorrect: function () {
      if (this.questionAnswered) {
        return this.keynumber == this.correctVariant
      }
    }
  },
        props: ['text', 'keynumber', 'imgSrc', 'desc', 'questionAnswered', 'selectedVariant', 'correctVariant'],
        methods : {
            selectVariant : function(keynumber) {
                if (!this.questionAnswered) {
                    this.$emit('variant-selected', keynumber);
                }
            },
        },
    }
</script>

<style lang="scss">
</style>
